import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import AddUserIcon from '../../Visuals/Icons/AddUser.icon';
import SubcontractorIcon from '../../Visuals/Icons/SubcontractorIcon.icon';
import UsersIcon from '../../Visuals/Icons/UsersIcon.icon';
import CloudUploadIcon from '../../Visuals/Icons/CloudUpload.icon';
import DocumentIcon from '../../Visuals/Icons/DocumentIcon.icon';
import CreditCardIcon from '../../Visuals/Icons/CreditCardIcon.icon';
import ReceiptIcon from '../../Visuals/Icons/ReceiptIcon.icon';
import SettingsIcon from '../../Visuals/Icons/SettingsIcon.icon';
import DashboardIcon from '../../Visuals/Icons/DashboardIcon.icon';
import LogoutIcon from '../../Visuals/Icons/LogoutIcon.icon';
import DownIcon from '../../Visuals/Icons/ChevronDown.icon';

const CompanySideMenu = ({ Auth, id }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [openCategory, setOpenCategory] = useState(null);

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };

  return (
    <div className="sideMenu">
      {/* Employee Management */}
      <div>
        <div
          className="menuCategory"
          onClick={() => toggleCategory('employeeManagement')}
        >
          <h4 onClick={() => toggleCategory('employeeManagement')}>
            Manager & Employee Management
          </h4>
          <DownIcon functionName={() => toggleCategory('employeeManagement')} />
        </div>

        {openCategory === 'employeeManagement' && (
          <div className="menuItems">
            <Link
              className="subLink"
              to={`/company/create-manager-employee/${id}`}
            >
              <AddUserIcon />
              Create Employee/Manager
            </Link>
            {isMobile && (
              <Link className="subLink" to={`/company/employees/${id}`}>
                <UsersIcon />
                Managers & Employees
              </Link>
            )}
          </div>
        )}
      </div>

      {/* Subcontractor Management */}
      {(process.env.REACT_APP_PRODUCTION === undefined ||
        process.env.REACT_APP_PRODUCTION === 'false') && (
        <div>
          <div
            onClick={() => toggleCategory('subcontractorManagement')}
            className="menuCategory"
          >
            <h4 onClick={() => toggleCategory('subcontractorManagement')}>
              Subcontractor Management
            </h4>
            <DownIcon
              functionName={() => toggleCategory('subcontractorManagement')}
            />
          </div>
          {openCategory === 'subcontractorManagement' && (
            <div className="menuItems">
              <Link
                className="subLink"
                to={`/company/create-subcontractor/${id}`}
              >
                <SubcontractorIcon />
                Create Subcontractor
              </Link>
              <Link className="subLink" to={`/company/upload-form/${id}`}>
                <CloudUploadIcon />
                Upload Form
              </Link>
              <Link className="subLink" to={`/company/forms/${id}`}>
                <DocumentIcon />
                Forms
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Training */}
      <div>
        <div
          className="menuCategory"
          onClick={() => toggleCategory('training')}
        >
          <h4 onClick={() => toggleCategory('training')}>Training</h4>
          <DownIcon functionName={() => toggleCategory('training')} />
        </div>
        {openCategory === 'training' && (
          <div className="menuItems">
            <Link className="subLink" to={`/company/training-list/${id}`}>
              <CreditCardIcon />
              Training List
            </Link>
            <Link className="subLink" to={`/company/buy-courses/${id}`}>
              <CreditCardIcon />
              Purchase Courses
            </Link>
            <Link className="subLink" to={`/company/purchase-history/${id}`}>
              <ReceiptIcon />
              Purchase History
            </Link>
          </div>
        )}
      </div>

      {/* Settings */}
      <div>
        <div
          className="menuCategory"
          onClick={() => toggleCategory('settings')}
        >
          <h4 onClick={() => toggleCategory('settings')}>Settings</h4>
          <DownIcon functionName={() => toggleCategory('settings')} />
        </div>
        {openCategory === 'settings' && (
          <div className="menuItems">
            <Link className="subLink" to={`/company/settings/${id}`}>
              <SettingsIcon />
              Edit Company Information
            </Link>
          </div>
        )}
      </div>

      {/* User Dashboard */}
      <Link
        className="subLink portal"
        style={{ marginTop: '1rem' }}
        to={`/user`}
      >
        <DashboardIcon />
        User Dashboard
      </Link>

      {/* Logout */}
      <Link
        onClick={(e) => {
          e.preventDefault();
          Auth.logout();
          window.location.assign('/');
        }}
        title="Logout"
        style={{ marginTop: '1rem' }}
        className="subLink"
        to="/about"
      >
        <LogoutIcon />
        Logout
      </Link>
    </div>
  );
};

CompanySideMenu.propTypes = {
  Auth: PropTypes.shape({
    logout: PropTypes.func,
  }),
  id: PropTypes.string,
};

export default CompanySideMenu;
